import { Constants } from "@constants";
import { createSlice } from "@reduxjs/toolkit";
import apiService from "@utils/apiService";
import { verifyApiResponse } from "@utils/apiResponseHelper";

const initialState = {
  loading: false,
  error: false,
  success: false,
  validateLoading: false,
  validateError: false,
  invalidEmails: [],
};

export const shareMailSlice = createSlice({
  name: "shareMail",
  initialState,
  reducers: {
    shareMailStart: (state) => ({
      ...state,
      loading: true,
      error: false,
    }),
    shareMailSuccess: (state) => ({
      ...state,
      loading: false,
      success: true,
    }),
    shareMailFailure: (state) => ({
      ...state,
      loading: false,
      error: true,
    }),
    validateMailStart: (state) => ({
      ...state,
      validateLoading: true,
      validateError: false,
    }),
    validateMailSuccess: (state, action) => ({
      ...state,
      validateLoading: false,
      invalidEmails: action.payload?.invalidEmails,
    }),
    validateMailFailure: (state) => ({
      ...state,
      validateLoading: false,
      validateError: true,
    }),
    resetMail: () => ({
      ...initialState
    })
  },
});

const { actions, reducer } = shareMailSlice;

export const { 
  shareMailStart,
  shareMailSuccess,
  shareMailFailure,
  validateMailStart,
  validateMailSuccess,
  validateMailFailure,
  resetMail,
} = actions;

export const shareMailsWithMessage = (payload, id, fromCaseExample) => (dispatch) => {
  dispatch(shareMailStart());
  const apiPath = fromCaseExample ? 
    `${Constants.API.CASE_EXAMPLES}/${id}${Constants.API.SHARE_MAIL}` : 
    `${Constants.API.USE_CASE_DETAIL}/${id}${Constants.API.SHARE_MAIL}`;

  apiService.post(apiPath, payload)
  .then((response) => {
    let data = verifyApiResponse(response);
    if (data?.systemMessage?.success) {
      dispatch(shareMailSuccess());
    } else {
      dispatch(shareMailFailure());
    }
  }).catch(() => {
      dispatch(shareMailFailure());
  })
}

export const validateMails = (payload) => (dispatch) => {
  dispatch(validateMailStart());
  apiService.post(
    `${Constants.API.USE_CASE_DETAIL}${Constants.API.SHARE_MAIL_VALIDATE}`,
    payload
  ).then((response) => {
    let data = verifyApiResponse(response);
    if (data?.systemMessage?.success && Object.keys(data?.data).length) {
      dispatch(validateMailSuccess(data?.data));
    } else {
      dispatch(validateMailFailure());
    }
  }).catch(() => {
      dispatch(validateMailFailure());
  })
}

export default reducer;
